import { useTranslation } from 'react-i18next';
import { Badge } from '@erp/ui';
import type { PaymentStatus } from '@erp/domain/payments';

const STYLES: Record<PaymentStatus, string> = {
  paid: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-400',
  unpaid: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-400',
  partially_paid: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-400',
};

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant="outline" className={STYLES[status]}>
      {t(`payments.status.${status}`)}
    </Badge>
  );
}
